import React, { useEffect, useState } from 'react';
import api from '../services/api';
import '../styles/Dashboard.css';

const Dashboard: React.FC = () => {
    const [stats, setStats] = useState({
        documents: 0,
        clients: 0,
        totalRequests: 0,
        pendingRequests: 0,
        completedRequests: 0,
    });

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const [documentsRes, clientsRes, requestsRes] = await Promise.all([
                    api.get('/files'),
                    api.get('/customers'),
                    api.get('/requests'),
                ]);

                const totalRequests = requestsRes.data.length;
                const pendingRequests = requestsRes.data.filter((req: any) => req.status === 'Pending').length;
                const completedRequests = requestsRes.data.filter((req: any) => req.status === 'Signed').length;

                setStats({
                    documents: documentsRes.data.length,
                    clients: clientsRes.data.length,
                    totalRequests,
                    pendingRequests,
                    completedRequests,
                });
            } catch (error) {
                console.error('Error fetching dashboard stats:', error);
            }
        };

        fetchStats();
    }, []);

    return (
        <div className="dashboard">
            <h1>Dashboard</h1>
            <div className="stats">
                <div className="stat">
                    <h2>Documents</h2>
                    <p>{stats.documents}</p>
                </div>
                <div className="stat">
                    <h2>Clients</h2>
                    <p>{stats.clients}</p>
                </div>
                <div className="stat">
                    <h2>Total Requests</h2>
                    <p>{stats.totalRequests}</p>
                </div>
                <div className="stat">
                    <h2>Pending Requests</h2>
                    <p>{stats.pendingRequests}</p>
                </div>
                <div className="stat">
                    <h2>Completed Requests</h2>
                    <p>{stats.completedRequests}</p>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;